import { createFileRoute, redirect } from '@tanstack/react-router';
import { getStoredOrgSlug, isSignedIn } from '@/app/auth';

// "/" is a redirect to the signed-in user's org home. If not signed
// in the root guard kicks them to /auth before this fires; if signed
// in but no slug stored (corrupted state) we fall back to /auth too.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    if (!isSignedIn()) {
      throw redirect({ to: '/auth' });
    }
    const slug = getStoredOrgSlug();
    if (!slug) {
      throw redirect({ to: '/auth' });
    }
    // Runtime-computed path (slug is dynamic) — use href, not the typed `to`.
    throw redirect({ href: `/${encodeURIComponent(slug)}/` });
  },
});
